export interface Faculty {
  firstName: string;
  lastName: string;
  photoUrl: string;
  bio: string;
  position: string;
  coursesTaught: string;
  facultySince: string;
  researchArea: string;
  recentPublications: string;
  major?: string;
  email: string;
  phone: string;
  quotes: string[];
  id: string;

  display: boolean;
  type: "faculty";

  // I shouldn't have to do this, but it gets by for now
  location?: string;
}

export const emptyFaculty: Faculty = {
  bio: "",
  coursesTaught: "",
  email: "",
  facultySince: "",
  display: true,
  firstName: "",
  id: "",
  lastName: "",
  phone: "",
  photoUrl: "",
  position: "",
  quotes: [],
  recentPublications: "",
  researchArea: "",
  type: "faculty",
};
